import { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import DeliverySignOutComponent from './DeliverySignOutComponent';

import { deliveriesSignOut, getDeliveries } from '../../Delivery/actions';

import { sortByKey } from '../../../utils';

import { DELIVERY_LIST_KEY } from '../../Delivery/constants';

import * as commonSelectors from '../../Shared/selectors';

import PackagesContext from '../Packages/context';

const DeliverySignOutContainer = (props) => {
  const {
    onGetDeliveries,
    unit,
    deliveriesSignOut,
    onModalClose,
    isSelfSignOut,
  } = props;

  const [unitDeliveries, setUnitDeliveries] = useState([]);
  const [unitResidents, setUnitResidents] = useState([]);
  const [checkedDeliveries, setCheckedDeliveries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const { setPackageChanged } = useContext(PackagesContext);

  useEffect(() => {
    const { id, parentProperty } = unit;
    const queryParams = {
      building: parentProperty,
      unit: id,
      disable_pagination: true,
      sign_out_state: 'pending',
    };
    const getDeliveries = async () => {
      try {
        setIsLoading(true);
        const res = await onGetDeliveries(queryParams, true);
        setUnitDeliveries(res?.data);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
      }
    };
    getDeliveries();
  }, []);

  useEffect(() => {
    if (!unitResidents?.length && unitDeliveries?.length) {
      const residents = [];
      unitDeliveries.forEach(({ recipient }) => {
        if (residents.find(({ id }) => id === recipient?.id)) return;
        const person = recipient
          ? {
              ...recipient,
              roles: [{ role: recipient?.role }],
            }
          : { isUnitDelivery: true };
        if (recipient?.id === unit?.recipientId) {
          residents.unshift(person);
        } else {
          residents.push(person);
        }
      });
      isSelfSignOut &&
        residents.sort((a, b) => sortByKey(a, b, 'isUnitDelivery'));
      setUnitResidents(residents);
    }
  }, [unitDeliveries]);

  const onDeliverySignOutChange = (delivery, isChecked) => {
    const { id } = delivery;
    let newCheckedDeliveries = [...checkedDeliveries];
    if (isChecked) {
      newCheckedDeliveries.push(id);
    } else {
      newCheckedDeliveries = newCheckedDeliveries.filter(
        (deliveryId) => deliveryId !== id,
      );
    }
    setCheckedDeliveries(newCheckedDeliveries);
  };

  const onDeliverySignOut = async () => {
    const data = {
      deliveries: checkedDeliveries, // list of deliveries
      signOutType: isSelfSignOut ? 'self service' : 'front-desk toggle', // { "self service", "front-desk signature", "front-desk toggle" }, note that this field is nullable
    };
    const res = await deliveriesSignOut(data);
    if (!res) return;
    setPackageChanged();
    onModalClose();
  };

  return (
    <DeliverySignOutComponent
      unit={unit}
      unitDeliveries={unitDeliveries}
      unitResidents={unitResidents}
      isLoading={isLoading}
      checkedDeliveries={checkedDeliveries}
      onDeliverySignOutChange={onDeliverySignOutChange}
      onDeliverySignOut={onDeliverySignOut}
      isSelfSignOut={isSelfSignOut}
    />
  );
};

DeliverySignOutContainer.propTypes = {
  onGetDeliveries: PropTypes.func.isRequired,
  deliveriesSignOut: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
  unit: PropTypes.instanceOf(Object).isRequired,
  isSelfSignOut: PropTypes.bool,
};

const mapStateToProps = (state) => {
  const deliveryListParams = commonSelectors.getListParams(
    state,
    DELIVERY_LIST_KEY,
  );
  return {
    deliveryListParams,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onGetDeliveries: (queryParams, isExport) =>
    getDeliveries(dispatch, queryParams, isExport),
  deliveriesSignOut: (data) => deliveriesSignOut(dispatch, data),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeliverySignOutContainer);
